export default () => ({
  activeWorkspace: null,
  activeWorkspaceBankAccount: null,
  signatureFooterSettings: {},
  workspaceSettings: null,
  workspaceBankAccounts: [],
  membersJobPositions: [],
});
